import { Deserializer } from "jsonapi-serializer";
import { DeviceParameter } from "../models/DeviceParameter";
import { genericError } from "../models/GenericError";
import { ListQuery } from "../models/ListQuery";
import { DeviceParameterWrapper } from "../models/wrappers/DeviceParameterWrapper";
import { APIConnector } from "./api/APIConnector";
import { createPagination } from "./utilities/paginationBuilder";
import { processServerError, getConstraintViolation } from "./utilities/ServiceError";
import { getDeviceSettingStatus } from "./utilities/StatusBuilder";
import { createPartialURL, getFilterClause } from "./utilities/urlBuilder";

const apiConnector = new APIConnector();

export const getDeviceParameters = async (itemId: string, listParameters?: ListQuery): Promise<DeviceParameterWrapper> => {
    try {
        const filter: string = getFilterClause(listParameters?.filters, listParameters?.searchTerm);
        const paginationString = createPartialURL(listParameters?.goToPage, listParameters?.pageSize, listParameters?.sortBy, filter);
        const deviceImproxFields = 'fields[deviceImprox]=devParams,deviceParameter';
        const devParamsFields = 'fields[devParam]=deviceParameter,setting';
        const deviceParameterFields = 'fields[deviceParameter]=deviceParamType';
        const deviceParamTypeFields = 'fields[deviceParamType]=dptName';
        const settingFields = 'fields[setting]=hierarchyType';
        const url = `deviceImprox/${itemId}/devParams?include=deviceParameter,deviceParameter.deviceParamType,setting.settingType${paginationString}&${deviceImproxFields}&${devParamsFields}&${deviceParameterFields}&${deviceParamTypeFields}&${settingFields}`;
        const response = await apiConnector.fetchData(url);
        const json = await response.json();
        const pagination = createPagination(json.meta);

        return new Promise((resolve, reject) => {
            if (json.errors) {
                return reject({status: response.status, message: getConstraintViolation(json.errors[0].detail) })
            }
            new Deserializer().deserialize(json, (error: any, data: any[]) => {
                if (error) {
                    return reject({status: response.status, message: genericError });
                }

                const deviceParameter: DeviceParameter[] = data.map((deviceParameter): DeviceParameter => {
                    return {
                        id: deviceParameter['id'],
                        name: deviceParameter['device-parameter']['device-param-type']['dpt-name'],
                        status: getDeviceSettingStatus(deviceParameter['setting']?.['hierarchy-type'] ? deviceParameter['setting']['hierarchy-type'] : 0)
                    }
                })

                return resolve({ rows: deviceParameter, pagination });
            })
        });
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error));
        });
    }
}
